module.exports = __webpack_public_path__ + "static/media/Placeholder.b638c4c3.svg";